function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilled40X40Px = function SvgFilled40X40Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    x: 20.49,
    y: -2,
    fill: "#E2001A",
    rx: 5,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "rotate(46.625 20.49 -2)"
  }));
};
export default SvgFilled40X40Px;